import { Component } from '@angular/core';

@Component({
	selector: 'app-user-registration-success-message-page',
	standalone: true,
	imports: [],
	templateUrl: './user-registration-success-message-page.component.html',
	styleUrl: './user-registration-success-message-page.component.scss'
})
export class UserRegistrationSuccessMessagePageComponent {
}
